<template>
  <div v-loading.fullscreen.lock="loading" class="comfrim_order" ref="orderConfirm">
    <!-- 头部 -->
    <top-part :rightPart="true"></top-part>
    <!-- 头部 结束 -->
        
    <!-- 收货地址 -->
    <!-- 有数据时 -->
    <div class="order_address ctn_top" v-if="defaultAddress" @click="toAddressList">
      <div class="address_1">
        <div>收货人：</div>
        <div style="margin-top:20px;">收货地址：</div>
      </div>
      <div class="address_2">
        <div class="address_2_text"  style="padding-bottom:15px;">
          <div class="address_name">{{defaultAddress.receiverName}}</div> 
          <div style="line-height:16px;">{{defaultAddress.receiverPhone}}</div>
        </div>
        <div >{{detailAddress}}</div>
      </div>
      <div  class="address_3"><img src="@/images/icon_right.png" alt /></div>
    </div>
    <!-- 无数据时 -->
    <div class="address_none ctn_top" v-else @click="toAddressList">
      <div>
        <img class="none_1_img" src="@/images/location.png" alt />
        <span>添加收货人信息</span>
      </div>
      <div><img  class="none_2_img" src="@/images/icon_right.png" alt /></div>
    </div>
    <!-- 收货地址 结束 -->

    <!-- 商品 -->
    <div class="goods_detail">
      <div class="goods_list" @click="toGoods">
        <div>
          <img :src="productInfo.mainImage" />
          <div class="goods_count">
            <div>{{productInfo.productName}}</div>
            <div>x1</div>
          </div>
        </div>
        <img src="@/images/icon_right.png" alt />
      </div>
      <!-- <div class="goods_order">
        <div>订单编号</div>
        <div>48784545464546546464566</div>
      </div> -->
    </div>
    
    <!-- 商品 结束 -->
    <div class="btn_order" @click="toSuccess" v-loading="btnLoading">立即兑换</div>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
export default {
  components: {
    topPart
  },
  data() {
    return {
      loading:false,
      defaultAddress:'',
      productInfo:'',
      btnLoading:false,
      detailAddress:'',
      eventFlag:false,
      category:''
    };
  },
  deactivated(){
    this.eventFlag=false;
  },
  activated(){
    if(!this.eventFlag)this.queryFn();
  },
  //组件删除执行
  destroyed(){
    //删除监听者
    this.deleteBrother("addressList")
  },
  created(){
    //挂载观察者
    this.centralControl.notice.onBrother("addressList", (data) => {
      this.defaultAddress=data;
      this.eventFlag=true;
      this.detailAddress= data.provinceName+' '+ data.cityName+' '+ data.areaName+' '+ data.address;
    });
  },
  mounted(){
     this.category =  this.$route.query.welfareCategory
    this.$refs.orderConfirm.scrollTop = 0
    this.queryFn(); 
  },
  methods:{
     //删除监听者
    deleteBrother(str){
      this.centralControl.notice.offBrother(str);
    },
    // 查询订单详情
    queryFn(){
      const {id,welfareCategory} = this.$route.query;
      this.centralControl.axios.centralControl(
        "createOrder",
        res => {
          this.loading=false;
          const {code,message,data} = res;
          if (code == 200) {
            const {defaultAddress,productInfo}=data;
            this.defaultAddress=defaultAddress;
            this.productInfo=productInfo;
            this.detailAddress=defaultAddress.provinceName+' '+defaultAddress.cityName+' '+defaultAddress.areaName+' '+defaultAddress.address;
            
          } else {
            toast(this, message,"error");
          }
        },
        {productId:id,welfareCategory:welfareCategory}
      );
    },
    //跳转新增地址 
    toNewAddress(){
      let obj = {
        path:'addressNew',
        query:{
          welfareCategory:this.category
        }
      }
      this.$router.push(obj)
    },
    // 跳转地址列表
    toAddressList(){
      this.$router.push({
        path:'addressList',
        query:{
          id:this.defaultAddress.id,
          welfareCategory:this.category
        }
      })
    },
    // 立即兑换
    toSuccess(){
      const {id,welfareId,welfareCategory} = this.$route.query;
      const {provinceId,provinceName,cityId,cityName,areaId,areaName,address,receiverPhone} = this.defaultAddress;
       let params={
        productId:id,
        welfareId,
        provinceId,
        provinceName,
        cityId,
        cityName,
        areaId,
        areaName,
        address,
        staffPhone:receiverPhone,
        welfareCategory: welfareCategory,
        receiveName:this.defaultAddress.receiverName
      }
      if(!provinceId || !cityId || !areaId || !receiverPhone ||!address )return toast(this, '请填写收货人信息',"error");
      this.btnLoading=true;
      this.centralControl.axios.centralControl(
        "saveOrder",
        res => {
          this.btnLoading=false;
          this.loading=false;
          const {code,message,data} = res;
          if (code == 200) {
            this.$router.push({
              path: 'orderConfrimSuccess',
              query:{
                welfareCategory:this.category
              }
            })
          } else {
            toast(this, message,"error");
          }
        },
        params
      );
    },
    // 跳转商品详情
    toGoods(){
      this.$router.go(-1);
    },
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
  .comfrim_order{
    overflow: auto;
    .address_none {
      background: #FFF;
      display: flex;
      justify-content: space-between;
      padding: 32px 7px 32px 16px;
      .none_1_img {
        width: 14px;
        margin-right: 8px;
      }
      .none_2_img {
        width: 24px;
      }
      span {
        font-size:14px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(41,190,188,1);
        line-height:20px;
        display: inline-block;
      }
    }
    .order_address {
      display: flex;
      // align-items: center;
      justify-content: space-between;
      background: #FFF;
      padding: 11px 0 11px 16px;
      .address_1 {
        width: 72px;
      }
      .address_2 {
        max-width: 72%;
       
      }
      .address_3 {
        img {
          width: 26px;
          margin-top: 16px;
        }
      }
      .address_1>div {
        font-size:14px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(53,53,53,1)
      }
       .address_2>div {
        font-size:14px;
        font-family:PingFang-SC-Medium,PingFang-SC;
        font-weight:500;
        color:rgba(136,136,136,1);
      }
      .address_2>div:nth-child(2){
        line-height: 20px;
      }
    }
    .goods_detail {
      background: #FFF;
      margin-top: 10px;
      >div {
        display: flex;  
      }
      .goods_order {
        padding: 16px;
        >div:nth-child(1){
          width: 90px;
          font-size:14px;
          font-family:PingFang-SC-Medium,PingFang-SC;
          font-weight:500;
          color:rgba(53,53,53,1);
        }
        >div:nth-child(2){
          font-size:14px;
          font-family:PingFang-SC-Medium,PingFang-SC;
          font-weight:500;
          color:rgba(136,136,136,1);
        }
      }
    }
    .goods_list {
      padding: 9px 0 9px 16px;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #F5F6FB;
      >div:nth-child(1){
        display :flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }
      }
      .goods_count {
        height: 40px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        >div:nth-child(1){
          font-size:16px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(53,53,53,1);
        }
        >div:nth-child(2){
          font-size:13px;
          font-family:PingFang-SC-Medium,PingFang-SC;
          font-weight:500;
          color:rgba(202,202,210,1);
        }
      }
      // .goods_right {
        img {
          width: 26px;
          // margin-top: 16px;
        }
      // }
    }
   
  }
  .address_2_text {
    display: flex;
    line-height: 0.4rem
  }
  .address_name {
    font-size:15px;
    font-family:PingFang SC;
    margin-right: 6px;
    ellipsis();
    max-width: 76px;
    line-height 16px;
  
  }
   .btn_order {
        margin: 16px;
        background:rgba(41,190,188,1);
        border-radius:5px;
        font-size:18px;
        font-family:PingFangSC-Semibold,PingFang SC;
        // font-weight:600;
        color:rgba(255,255,255,1);
        line-height:44px;
        text-align: center;
        height: 44px;
    }
</style>